(function () {
  'use strict';

  const wrap = document.getElementById('sc-cad-wrap');
  if (!wrap) return;

  const WORKER_ENDPOINT = (wrap.dataset.workerEndpoint || '').replace(/\/$/, '');

  // — DOM refs —
  const elLoading = document.getElementById('sc-cad-loading');
  const elInvalid = document.getElementById('sc-cad-invalid');
  const elUsed    = document.getElementById('sc-cad-used');
  const elCard    = document.getElementById('sc-cad-card');

  // — State —
  let inviteData       = {};  // { id, token, email, name, couponCode }
  let selectedProducts = [];
  let photoFile        = null;

  // — Registro profissional —
  // Categorias com prefixo fixo: o prefixo aparece travado no campo e o
  // usuário digita apenas os números (validação só nos dígitos).
  // 4 a 10 dígitos, com sufixo opcional "/UF" (2 letras) para indicar o estado.
  const REGISTRO_PREFIX_RE = /^\d{4,10}(\/[A-Za-z]{2})?$/;
  const REGISTRO_RULES = {
    'Nutricionista': 'CRN-',
    'Nutrólogo': 'CRM-',
    'Educador Físico': 'CREF-',
    'Profissional de Educação Física': 'CREF-',
    'Personal Trainer': 'CREF-',
    'Fisioterapeuta': 'CREFITO-',
    'Fisiologista do Exercício': 'CREF-',
    'Médico': 'CRM-',
    'Médico do Esporte': 'CRM-',
    'Médico Integrativo': 'CRM-',
    'Endocrinologista': 'CRM-',
    'Ortopedista': 'CRM-',
    'Cardiologista': 'CRM-',
    'Médico do Sono': 'CRM-',
    'Geneticista': 'CRM-',
    'Metabologista': 'CRM-',
    'Psicólogo do Esporte': 'CRP-',
    'Farmacêutico': 'CRF-',
  };
  // 'Outro' não tem prefixo fixo — mantém a validação livre (prefixo + número digitados).
  const REGISTRO_OUTRO_RE = /^[A-Z]{3,5}-\d{4,10}(\/[A-Za-z]{2})?$/;

  // ─────────────────────────────────────
  // INIT
  // ─────────────────────────────────────
  init();

  async function init() {
    const token = new URLSearchParams(window.location.search).get('token');

    if (!token) { showState('invalid'); return; }

    if (!WORKER_ENDPOINT) {
      console.warn('[SC Connect] workerEndpoint não configurado — configure nas settings da seção.');
      showState('invalid');
      return;
    }

    try {
      const res = await fetch(WORKER_ENDPOINT + '/api/connect/validate?token=' + encodeURIComponent(token));

      if (res.status === 404) { showState('invalid'); return; }
      if (res.status === 410) { showState('used');    return; }
      if (!res.ok)            { showState('invalid'); return; }

      const data = await res.json();

      inviteData = {
        id:         data.id,
        token,
        email:      data.email       || '',
        name:       data.name        || '',
        couponCode: data.coupon_code || '',
      };

      prefill();
      initCategoriaSelect();
      showState('form');
    } catch (e) {
      console.error('[SC Connect] validate error:', e);
      showState('invalid');
    }
  }

  // ─────────────────────────────────────
  // PRODUCT SEARCH via Worker
  // ─────────────────────────────────────
  async function searchProducts(q) {
    const res  = await fetch(WORKER_ENDPOINT + '/api/connect/products?q=' + encodeURIComponent(q));
    const data = await res.json();
    return data.products || [];
  }

  // ─────────────────────────────────────
  // STATE
  // ─────────────────────────────────────
  function showState(state) {
    elLoading.hidden = true;
    elInvalid.hidden = state !== 'invalid';
    elUsed.hidden    = state !== 'used';
    elCard.hidden    = state !== 'form';
  }

  // ─────────────────────────────────────
  // CUSTOM SELECT — CATEGORIA
  // ─────────────────────────────────────
  function initCategoriaSelect() {
    const trigger = document.getElementById('sc-categoria-trigger');
    const dropdown = document.getElementById('sc-categoria-dropdown');
    const selectValue = trigger.querySelector('.sc-cad-select-value');
    const hiddenSelect = get('sc-categoria');
    const options = dropdown.querySelectorAll('.sc-cad-select-option');

    trigger.addEventListener('click', e => {
      e.stopPropagation();
      const isOpen = dropdown.classList.contains('is-open');
      closeAllSelects();
      if (!isOpen) {
        dropdown.classList.add('is-open');
        trigger.setAttribute('aria-expanded', 'true');
      }
    });

    options.forEach(option => {
      option.addEventListener('click', () => {
        const value = option.dataset.value;
        const text = option.textContent;
        selectValue.textContent = text || 'Selecione sua categoria';
        hiddenSelect.value = value;
        options.forEach(o => o.classList.remove('is-selected'));
        option.classList.add('is-selected');
        dropdown.classList.remove('is-open');
        trigger.setAttribute('aria-expanded', 'false');
        document.getElementById('sc-categoria-err')?.classList.remove('is-visible');
        trigger.classList.remove('is-error');
        hiddenSelect.dispatchEvent(new Event('change', { bubbles: true }));
        updateRegistroState();
      });
    });
  }

  function closeAllSelects() {
    document.querySelectorAll('.sc-cad-select-dropdown').forEach(dd => {
      dd.classList.remove('is-open');
    });
    document.querySelectorAll('.sc-cad-select-trigger').forEach(t => {
      t.setAttribute('aria-expanded', 'false');
    });
  }

  document.addEventListener('click', () => closeAllSelects());
  document.addEventListener('keydown', e => {
    if (e.key === 'Escape') closeAllSelects();
  });

  // ─────────────────────────────────────
  // PREFILL
  // ─────────────────────────────────────
  function prefill() {
    if (inviteData.name)       get('sc-nome').value  = inviteData.name;
    if (inviteData.email)      get('sc-email').value = inviteData.email;
    if (inviteData.couponCode) {
      get('sc-cupom').value = inviteData.couponCode;
      updateCouponPreview(inviteData.couponCode);
    }
  }

  // ─────────────────────────────────────
  // PROGRESS
  // ─────────────────────────────────────
  function updateProgress(step) {
    document.querySelectorAll('[data-dot]').forEach(el => {
      const n = parseInt(el.dataset.dot);
      el.classList.toggle('is-active', n === step);
      el.classList.toggle('is-done',   n < step);
    });
    document.querySelectorAll('[data-line]').forEach(el => {
      el.classList.toggle('is-done', parseInt(el.dataset.line) < step);
    });
  }

  function goTo(step) {
    document.querySelectorAll('.sc-cad-step').forEach(el => {
      el.classList.toggle('is-active', el.dataset.step === String(step));
    });
    if (step !== 'success') updateProgress(step);
    elCard.scrollIntoView({ behavior: 'smooth', block: 'nearest' });
  }

  // ─────────────────────────────────────
  // STEP 1
  // ─────────────────────────────────────
  get('sc-cupom').addEventListener('input', e => updateCouponPreview(e.target.value));

  const whatsappEl = get('sc-whatsapp');
  whatsappEl.addEventListener('input', handleWhatsappInput);
  // Sem preventDefault (bloquear colar é falha de acessibilidade): deixa colar
  // e refaz o valor com o texto colado inteiro.
  whatsappEl.addEventListener('paste', e => {
    const pasted = (e.clipboardData || window.clipboardData).getData('text') || '';
    setTimeout(() => { whatsappEl.value = formatWhatsappValue(pasted); }, 0);
  });

  function handleWhatsappInput(e) {
    const formattedValue = formatWhatsappValue(e.target.value);
    if (formattedValue !== e.target.value) {
      e.target.value = formattedValue;
    }
  }

  function formatWhatsappValue(value) {
    const digits = String(value).replace(/\D/g, '').slice(0, 11);
    if (!digits) return '';
    if (digits.length <= 2) return `(${digits}`;
    if (digits.length <= 6) return `(${digits.slice(0, 2)}) ${digits.slice(2)}`;
    return `(${digits.slice(0, 2)}) ${digits.slice(2, 7)}-${digits.slice(7)}`;
  }

  function updateCouponPreview(val) {
    const fmt = (val || '').toUpperCase().replace(/[^A-Z0-9]/g, '').slice(0, 20) || 'SEUNOME';
    document.getElementById('sc-cupom-value').textContent = fmt;
  }

  get('sc-s1-next').addEventListener('click', () => { if (validateStep1()) goTo(2); });

  const categoriaEl = get('sc-categoria');
  const registroEl = get('sc-registro');
  const registroGroup = document.getElementById('sc-registro-group');
  const registroPrefix = document.getElementById('sc-registro-prefix');
  categoriaEl.addEventListener('change', updateRegistroState);

  // Clicar em qualquer área do grupo (inclusive sobre o prefixo) foca o input.
  registroGroup.addEventListener('click', () => {
    if (!registroEl.disabled) registroEl.focus();
  });

  // Categorias com prefixo fixo: dígitos + sufixo "/UF" opcional; limpa o erro ao digitar.
  registroEl.addEventListener('input', () => {
    if (REGISTRO_RULES[categoriaEl.value]) {
      const formatted = formatRegistroValue(registroEl.value);
      if (formatted !== registroEl.value) registroEl.value = formatted;
    }
    registroEl.classList.remove('is-error');
    registroGroup.classList.remove('is-error');
    document.getElementById('sc-registro-err')?.classList.remove('is-visible');
  });

  // Mantém só dígitos (até 10) e, se o usuário digitar "/", até 2 letras maiúsculas.
  function formatRegistroValue(raw) {
    const slashIdx = raw.indexOf('/');
    const digits = (slashIdx === -1 ? raw : raw.slice(0, slashIdx))
      .replace(/\D/g, '')
      .slice(0, 10);
    if (slashIdx === -1 || !digits) return digits;
    const uf = raw.slice(slashIdx + 1).replace(/[^A-Za-z]/g, '').toUpperCase().slice(0, 2);
    return digits + '/' + uf;
  }

  updateRegistroState();

  function setRegistroPrefix(prefix) {
    registroPrefix.textContent = prefix || '';
    registroPrefix.hidden = !prefix;
    registroGroup.classList.toggle('has-prefix', !!prefix);
  }

  function updateRegistroState() {
    const category = categoriaEl.value;
    const enabled = category !== '';
    const prefix = REGISTRO_RULES[category];

    registroEl.disabled = !enabled;
    registroGroup.classList.toggle('is-disabled', !enabled);
    registroEl.value = '';
    registroEl.classList.remove('is-error');
    registroGroup.classList.remove('is-error');
    document.getElementById('sc-registro-err')?.classList.remove('is-visible');

    if (!enabled) {
      setRegistroPrefix('');
      registroEl.placeholder = 'Selecione a categoria';
      registroEl.removeAttribute('inputmode');
      registroEl.removeAttribute('maxlength');
      return;
    }

    if (prefix) {
      // Prefixo fixo e travado — usuário digita os números (+ "/UF" opcional).
      setRegistroPrefix(prefix);
      registroEl.placeholder = 'Ex: 12345 ou 12345/SP';
      registroEl.removeAttribute('inputmode');
      registroEl.setAttribute('maxlength', '13');
    } else {
      // 'Outro' — comportamento livre (prefixo + número digitados).
      setRegistroPrefix('');
      registroEl.placeholder = 'EX: ABCD-12345';
      registroEl.removeAttribute('inputmode');
      registroEl.setAttribute('maxlength', '20');
    }
  }

  function validateRegistroByCategoria(value, category) {
    if (REGISTRO_RULES[category]) return REGISTRO_PREFIX_RE.test(value.trim());
    if (category === 'Outro') return REGISTRO_OUTRO_RE.test(value.trim());
    return value.trim().length > 0;
  }

  // Valor completo enviado ao backend: prefixo fixo + dígitos (ex.: "CRN-12345").
  function getRegistroValue() {
    const prefix = REGISTRO_RULES[categoriaEl.value];
    const val = registroEl.value.trim();
    return prefix ? prefix + val : val;
  }

  function validateStep1() {
    const rules = [
      { id: 'sc-nome',      errId: 'sc-nome-err',      ok: v => v.trim().length >= 2 },
      { id: 'sc-email',     errId: 'sc-email-err',     ok: v => /^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(v) },
      { id: 'sc-whatsapp',  errId: 'sc-whatsapp-err',  ok: v => v.replace(/\D/g, '').length >= 8 },
      { id: 'sc-instagram', errId: 'sc-instagram-err', ok: v => v.trim().length > 0 },
      { id: 'sc-categoria', errId: 'sc-categoria-err', ok: v => v !== '' },
      {
        id: 'sc-registro',
        errId: 'sc-registro-err',
        ok: v => validateRegistroByCategoria(v, get('sc-categoria').value),
      },
      { id: 'sc-cupom',     errId: 'sc-cupom-err',     ok: v => v.trim().length > 0 },
    ];
    let valid = true;
    rules.forEach(({ id, errId, ok }) => {
      const el  = get(id);
      const err = document.getElementById(errId);
      const pass = ok(el.value);
      el.classList.toggle('is-error', !pass);
      if (id === 'sc-categoria') {
        const trigger = document.getElementById('sc-categoria-trigger');
        if (trigger) trigger.classList.toggle('is-error', !pass);
      }
      if (id === 'sc-registro') {
        registroGroup.classList.toggle('is-error', !pass);
      }
      err.classList.toggle('is-visible', !pass);
      if (!pass) valid = false;
    });
    return valid;
  }

  // ─────────────────────────────────────
  // STEP 2
  // ─────────────────────────────────────
  get('sc-s2-back').addEventListener('click', () => goTo(1));
  get('sc-s2-next').addEventListener('click', () => { if (validateStep2()) goTo(3); });

  // Campos de localização aparecem quando a modalidade inclui atendimento presencial
  const presencialFields = get('sc-presencial-fields');
  const presencialIds = [['sc-uf', 'sc-uf-err'], ['sc-cidade', 'sc-cidade-err'], ['sc-endereco', 'sc-endereco-err']];

  function isPresencial() {
    const el = document.querySelector('input[name="modalidade"]:checked');
    return !!el && el.value.includes('Presencial');
  }

  function togglePresencialFields() {
    const show = isPresencial();
    presencialFields.hidden = !show;
    if (!show) {
      presencialIds.forEach(([id, errId]) => {
        get(id).classList.remove('is-error');
        document.getElementById(errId).classList.remove('is-visible');
      });
    }
  }

  document.querySelectorAll('input[name="modalidade"]').forEach(el => el.addEventListener('change', togglePresencialFields));
  togglePresencialFields();

  function validateStep2() {
    const perfilErr = document.getElementById('sc-perfil-err');
    const hasPerfil = [...document.querySelectorAll('input[name="perfil_paciente"]:checked')].length > 0;

    perfilErr.classList.toggle('is-visible', !hasPerfil);
    if (hasPerfil) {
      document.querySelectorAll('input[name="perfil_paciente"]').forEach(el => el.closest('label')?.classList.remove('is-error'));
    } else {
      document.querySelectorAll('input[name="perfil_paciente"]').forEach(el => el.closest('label')?.classList.add('is-error'));
    }

    let ok = hasPerfil;

    if (isPresencial()) {
      presencialIds.forEach(([id, errId]) => {
        const empty = !get(id).value.trim();
        get(id).classList.toggle('is-error', empty);
        document.getElementById(errId).classList.toggle('is-visible', empty);
        if (empty) ok = false;
      });
    }

    return ok;
  }

  // ─────────────────────────────────────
  // STEP 3 — products
  // ─────────────────────────────────────
  const productSearchEl  = get('sc-product-search');
  const productDropEl    = document.getElementById('sc-product-dropdown');
  const selectedProdEl   = document.getElementById('sc-selected-products');

  let searchTimer;
  productSearchEl.addEventListener('input', () => {
    clearTimeout(searchTimer);
    const q = productSearchEl.value.trim();
    if (q.length < 2) { productDropEl.classList.remove('is-open'); return; }
    searchTimer = setTimeout(() => loadProducts(q), 300);
  });

  document.addEventListener('click', e => {
    if (!e.target.closest('.sc-cad-product-wrap')) productDropEl.classList.remove('is-open');
  });

  async function loadProducts(q) {
    const prods = await searchProducts(q);
    if (!prods.length) { productDropEl.classList.remove('is-open'); return; }
    productDropEl.innerHTML = prods.map(p => {
      const img = p.images?.edges?.[0]?.node?.url || '';
      return `<div class="sc-cad-product-option" data-id="${p.id}" data-title="${escHtml(p.title)}" data-img="${img}">
        ${img ? `<img src="${img}" alt="" loading="lazy">` : ''}
        <span>${escHtml(p.title)}</span>
      </div>`;
    }).join('');
    productDropEl.classList.add('is-open');
    productDropEl.querySelectorAll('.sc-cad-product-option').forEach(el => {
      el.addEventListener('click', () => addProduct({
        id: el.dataset.id, title: el.dataset.title, img: el.dataset.img,
      }));
    });
  }

  function addProduct(prod) {
    if (selectedProducts.find(p => p.id === prod.id)) return;
    selectedProducts.push(prod);
    renderSelectedProducts();
    productDropEl.classList.remove('is-open');
    productSearchEl.value = '';
    document.getElementById('sc-products-err').classList.remove('is-visible');
    productSearchEl.classList.remove('is-error');
  }

  function removeProduct(id) {
    selectedProducts = selectedProducts.filter(p => p.id !== id);
    renderSelectedProducts();
  }

  function renderSelectedProducts() {
    selectedProdEl.innerHTML = selectedProducts.map(p => `
      <div class="sc-cad-selected-product">
        ${p.img ? `<img src="${p.img}" alt="" loading="lazy">` : ''}
        <span>${escHtml(p.title)}</span>
        <button type="button" class="sc-cad-selected-product__remove" data-id="${p.id}" aria-label="Remover">×</button>
      </div>
    `).join('');
    selectedProdEl.querySelectorAll('.sc-cad-selected-product__remove').forEach(btn => {
      btn.addEventListener('click', () => removeProduct(btn.dataset.id));
    });
  }

  // — Photo upload —
  const photoInputEl   = get('sc-photo-input');
  const photoPreviewEl = document.getElementById('sc-photo-preview');
  const photoTextEl    = document.getElementById('sc-photo-text');
  const photoDropEl    = document.getElementById('sc-photo-drop');
  const photoSpinnerEl = document.getElementById('sc-photo-spinner');

  photoInputEl.addEventListener('change', handlePhotoSelect);

  photoDropEl.addEventListener('dragover', e => { e.preventDefault(); photoDropEl.classList.add('is-dragover'); });
  photoDropEl.addEventListener('dragleave', () => photoDropEl.classList.remove('is-dragover'));
  photoDropEl.addEventListener('drop', e => {
    e.preventDefault();
    photoDropEl.classList.remove('is-dragover');
    const file = e.dataTransfer.files[0];
    if (file?.type.startsWith('image/')) {
      const dt = new DataTransfer();
      dt.items.add(file);
      photoInputEl.files = dt.files;
      handlePhotoSelect();
    }
  });

  function handlePhotoSelect() {
    const file = photoInputEl.files[0];
    if (!file) return;
    photoFile = file;
    photoSpinnerEl.classList.add('is-visible');
    photoPreviewEl.classList.remove('is-visible');
    photoTextEl.textContent = 'Carregando...';
    const reader = new FileReader();
    reader.onload = ev => {
      photoPreviewEl.src = ev.target.result;
      photoPreviewEl.classList.add('is-visible');
      photoSpinnerEl.classList.remove('is-visible');
      photoTextEl.textContent = file.name;
      document.getElementById('sc-photo-err').classList.remove('is-visible');
    };
    reader.readAsDataURL(file);
  }

  function validateStep3() {
    const productErr = document.getElementById('sc-products-err');
    const bioErr = document.getElementById('sc-bio-err');
    const photoErr = document.getElementById('sc-photo-err');

    const hasProduct = selectedProducts.length > 0;
    const hasBio = get('sc-bio').value.trim().length > 0;
    const hasPhoto = !!photoFile;

    productErr.classList.toggle('is-visible', !hasProduct);
    bioErr.classList.toggle('is-visible', !hasBio);
    photoErr.classList.toggle('is-visible', !hasPhoto);

    if (hasProduct) productSearchEl.classList.remove('is-error');
    if (hasBio) get('sc-bio').classList.remove('is-error');
    if (hasPhoto) photoDropEl.classList.remove('is-error');

    if (!hasProduct) productSearchEl.classList.add('is-error');
    if (!hasBio) get('sc-bio').classList.add('is-error');
    if (!hasPhoto) photoDropEl.classList.add('is-error');

    return hasProduct && hasBio && hasPhoto;
  }

  get('sc-s3-back').addEventListener('click', () => goTo(2));
  get('sc-s3-next').addEventListener('click', () => { if (validateStep3()) goTo(4); });

  // ─────────────────────────────────────
  // STEP 4 — terms & submit
  // ─────────────────────────────────────
  const termsEl  = get('sc-terms');
  const submitEl = get('sc-s4-submit');

  termsEl.addEventListener('change', () => { submitEl.disabled = !termsEl.checked; });
  get('sc-s4-back').addEventListener('click', () => goTo(3));
  submitEl.addEventListener('click', handleSubmit);

  async function handleSubmit() {
    if (!WORKER_ENDPOINT) {
      alert('Endpoint do Worker não configurado. Contate o suporte.');
      return;
    }

    submitEl.disabled  = true;
    submitEl.textContent = 'Enviando...';

    try {
      const fd = buildFormData();
      const res = await fetch(WORKER_ENDPOINT + '/api/connect/submit', {
        method: 'POST',
        body: fd,
      });
      const json = await res.json().catch(() => ({}));

      if (!res.ok || json.error) throw new Error(json.error || 'Erro desconhecido');

      goTo('success');
    } catch (e) {
      console.error('[SC Connect] submit error:', e);
      submitEl.disabled    = false;
      submitEl.textContent = 'Finalizar Perfil';
      alert('Erro ao enviar o cadastro: ' + e.message + '\nTente novamente ou entre em contato com o suporte.');
    }
  }

  function buildFormData() {
    const fd = new FormData();

    fd.append('token',      inviteData.token);
    fd.append('invite_id',  inviteData.id);

    // Step 1
    fd.append('nome',      get('sc-nome').value.trim());
    fd.append('email',     get('sc-email').value.trim());
    fd.append('whatsapp',  get('sc-whatsapp').value.replace(/\D/g, '').trim());
    fd.append('instagram', get('sc-instagram').value.trim());
    fd.append('categoria', get('sc-categoria').value);
    fd.append('registro',  getRegistroValue());
    fd.append('cupom',     get('sc-cupom').value.toUpperCase().replace(/[^A-Z0-9]/g, '').trim());

    // Step 2
    const radio = name => {
      const el = document.querySelector(`input[name="${name}"]:checked`);
      return el ? el.value : '';
    };
    const checks = name =>
      JSON.stringify([...document.querySelectorAll(`input[name="${name}"]:checked`)].map(el => el.value));

    fd.append('modalidade',      radio('modalidade'));

    const presencial = !get('sc-presencial-fields').hidden;
    fd.append('uf',       presencial ? get('sc-uf').value.trim().toUpperCase() : '');
    fd.append('cidade',   presencial ? get('sc-cidade').value.trim()           : '');
    fd.append('endereco', presencial ? get('sc-endereco').value.trim()         : '');

    fd.append('tipoatendimento', radio('tipo_atendimento'));
    fd.append('perfil_paciente',  checks('perfil_paciente'));

    // Step 3
    fd.append('produtos', JSON.stringify(selectedProducts.map(p => ({ id: p.id, title: p.title }))));
    fd.append('bio',      get('sc-bio').value.trim());

    if (photoFile) fd.append('foto', photoFile, photoFile.name);

    fd.append('termos_aceitos', 'true');

    return fd;
  }

  // ─────────────────────────────────────
  // HELPERS
  // ─────────────────────────────────────
  function get(id) { return document.getElementById(id); }

  function escHtml(str) {
    return String(str).replace(/[&<>"']/g, c =>
      ({ '&':'&amp;','<':'&lt;','>':'&gt;','"':'&quot;',"'":'&#39;' }[c])
    );
  }

})();
